'use strict';

/* ── HOW IT WORKS — TAB SWITCHING ── */
function ndInitHIW() {
  document.querySelectorAll('.nd-hiw-section').forEach(function(section) {
    var tabs = section.querySelectorAll('.nd-hiw-tab');
    var panels = section.querySelectorAll('.nd-hiw-panel');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = tab.dataset.tab;
        tabs.forEach(function(t) { t.classList.toggle('active', t.dataset.tab === target); });
        panels.forEach(function(p) { p.classList.toggle('active', p.dataset.tab === target); });
        var vid = section.querySelector('.nd-hiw-panel.active video');
        if (vid) {
          if (vid.dataset.deferSrc && !vid.src) {
            vid.src = vid.dataset.deferSrc;
            vid.removeAttribute('data-defer-src');
          }
          vid.play().catch(function(){});
        }
      });
    });
  });
}

/* ── VIDEO DEFER ──
   Videos opt in via `data-defer-src="<url>"` and `data-defer-strategy`:
     "load"    → load after window load event (use for above-fold videos that compete with LCP)
     "visible" → load when first scrolled into viewport (use for below-fold videos)        */
function ndInitVideoDefer() {
  function activate(v) {
    if (v.src || !v.dataset.deferSrc) return;
    v.src = v.dataset.deferSrc;
    v.removeAttribute('data-defer-src');
    v.play().catch(function(){});
  }

  // Load-event strategy
  var loadDefers = document.querySelectorAll('video[data-defer-src][data-defer-strategy="load"]');
  if (loadDefers.length) {
    function runLoadDefers() {
      // Small idle delay so LCP paint and post-load work settle first
      setTimeout(function() {
        loadDefers.forEach(activate);
      }, 250);
    }
    if (document.readyState === 'complete') runLoadDefers();
    else window.addEventListener('load', runLoadDefers, { once: true });
  }

  // Visibility strategy
  var visDefers = document.querySelectorAll('video[data-defer-src][data-defer-strategy="visible"]');
  if (visDefers.length) {
    if (!('IntersectionObserver' in window)) {
      visDefers.forEach(activate);
    } else {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            activate(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '300px 0px', threshold: 0.1 });
      visDefers.forEach(function(v) { io.observe(v); });
    }
  }
}

/* ── COMMUNITY LAZY VIDEO LOAD ──
   Cards rendered with `data-video-src` (not `src`) have their video bytes
   deferred until the card enters the viewport. Pauses when scrolled out
   to save battery/CPU.                                                  */
function ndInitCommunityLazy() {
  if (!('IntersectionObserver' in window)) {
    // Fallback: just load everything immediately.
    document.querySelectorAll('.nd-comm-card-vid[data-video-src]').forEach(function(v) {
      v.src = v.dataset.videoSrc;
      v.removeAttribute('data-video-src');
      v.play().catch(function(){});
    });
    return;
  }
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      var v = entry.target;
      if (entry.isIntersecting) {
        if (v.dataset.videoSrc && !v.src) {
          v.src = v.dataset.videoSrc;
          v.removeAttribute('data-video-src');
        }
        v.play().catch(function(){});
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { rootMargin: '200px 0px', threshold: 0.25 });

  document.querySelectorAll('.nd-comm-card-vid').forEach(function(v) { io.observe(v); });
}

/* ── COMMUNITY VIEW MORE TOGGLE ── */
function ndInitCommunityViewMore() {
  document.querySelectorAll('[data-comm-more]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var section = btn.closest('.nd-comm-section');
      if (!section) return;
      var extra = section.querySelector('[data-comm-extra]');
      if (!extra) return;
      extra.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      btn.setAttribute('hidden', 'hidden');
    });
  });
}

/* ── COMMUNITY MODAL ── */
function ndInitCommunity() {
  document.querySelectorAll('.nd-comm-section').forEach(function(section) {
    var modal = section.querySelector('.nd-comm-modal');
    if (!modal) return;
    var modalVid = modal.querySelector('.nd-comm-modal-vid');
    var modalPh = modal.querySelector('.nd-comm-modal-ph');

    section.querySelectorAll('.nd-comm-card').forEach(function(card) {
      card.addEventListener('click', function() {
        var username = card.dataset.username || '';
        var tag = card.dataset.tag || '';
        var color = card.dataset.color || '#F5A623';
        var videoUrl = card.dataset.video || '';

        var unameEl = modal.querySelector('.nd-comm-modal-uname');
        var tagEl = modal.querySelector('.nd-comm-modal-tag');
        var avatarEl = modal.querySelector('.nd-comm-modal-avatar');

        if (unameEl) unameEl.textContent = '@' + username;
        if (tagEl) tagEl.textContent = tag;
        if (avatarEl) { avatarEl.style.background = color + '22'; avatarEl.style.borderColor = color + '88'; }

        if (videoUrl && modalVid) {
          modalVid.src = videoUrl;
          modalVid.style.display = 'block';
          if (modalPh) modalPh.style.display = 'none';
          modalVid.play().catch(function(){});
        } else {
          if (modalVid) { modalVid.style.display = 'none'; modalVid.src = ''; }
          if (modalPh) modalPh.style.display = 'flex';
        }
        modal.classList.add('open');
        document.body.style.overflow = 'hidden';
      });
    });

    function closeModal() {
      modal.classList.remove('open');
      document.body.style.overflow = '';
      if (modalVid) { modalVid.pause(); modalVid.src = ''; }
    }

    var closeBtn = modal.querySelector('.nd-comm-modal-close');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function(e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('open')) closeModal();
    });
  });
}

/* ── A11Y SHIM: 3rd-party widgets that ship without alt/aria ──
   Shiprocket's WhatsApp widget injects <img id="whatsappIconWidget"> with no
   alt attribute. Watch for it and patch in accessible text once it appears. */
function ndInitA11yShims() {
  function patchEl(el) {
    if (!el || el.dataset.a11yPatched) return;
    if (el.id === 'whatsappIconWidget') {
      el.alt = 'Chat on WhatsApp';
    } else if (el.classList && el.classList.contains('jdgm-verified-count-badget')) {
      // Judge.me verified-badge link has href="javascript:void(0)" and no name.
      // Mark as decorative since the visible "Verified" badge text in the same widget already conveys meaning.
      el.setAttribute('aria-label', 'Verified reviews');
      el.setAttribute('role', 'img');
    }
    el.dataset.a11yPatched = '1';
  }
  function sweep(root) {
    if (!root || !root.querySelectorAll) return;
    var imgs = root.querySelectorAll('#whatsappIconWidget, .jdgm-verified-count-badget');
    for (var i = 0; i < imgs.length; i++) patchEl(imgs[i]);
  }
  sweep(document);
  if (!('MutationObserver' in window)) return;
  var obs = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        patchEl(n);
        sweep(n);
      }
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });
  setTimeout(function() { obs.disconnect(); }, 30000);
}

function ndInitAll() {
  ndInitVideoDefer();
  ndInitHIW();
  ndInitCommunity();
  ndInitCommunityLazy();
  ndInitCommunityViewMore();
  ndInitA11yShims();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ndInitAll);
} else {
  ndInitAll();
}
